import '@augmatica/ui/styles.css'
import { WaitlistForm } from './waitlist-form'

export function App() {
  return (
    <div className="page">
      <main className="page__main">
        <p className="hero__eyebrow">Private beta</p>
        <h1 className="hero__title">Join the waiting list</h1>

        <WaitlistForm />
      </main>
    </div>
  )
}
